var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-528 -374)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(528 374)",
    fill: "#6a6a6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.055 380.131l1.617 1.62a.272.272 0 10.385-.383l-1.621-1.619 1.621-1.621a.27.27 0 00-.385-.381l-1.617 1.621-1.621-1.621a.27.27 0 10-.381.381l1.619 1.621-1.619 1.619a.27.27 0 10.381.381zm0 0",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBadge);
export default __webpack_public_path__ + "static/media/closeBadge.97e9210f.svg";
export { ForwardRef as ReactComponent };